import { render, staticRenderFns } from "./InvestorSellerDebtorConfigTable.vue?vue&type=template&id=1d54a613&"
import script from "./InvestorSellerDebtorConfigTable.vue?vue&type=script&lang=js&"
export * from "./InvestorSellerDebtorConfigTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports